export default "__VITE_ASSET__D4mRMV17__"